import { Alert, AlertTitle } from "@mui/material";
import React from "react";

interface IBOPAlertProps {
	planName: string;
}

const BOPAlertCaution: React.FC<IBOPAlertProps> = ({ planName }) => {
	return (
		<Alert
			severity="error"
			style={{
				backgroundColor: "rgba(255, 214, 214, 0.7)",
				marginTop: "25%",
				// marginLeft: "85%",
				padding: "1rem",
				height: "auto",
				width: "80%",
				borderRadius: "0.8rem",
				boxShadow: "0px 0px 5px red",
				fontSize: "1rem",
				position: "absolute",
				zIndex: 1000,
				backdropFilter: "blur(10px)",
				WebkitBackdropFilter: "blur(10px)"
			}}
		>
			<AlertTitle>
				<strong>Caution!</strong>
			</AlertTitle>
			<div>
				You are currently not enrolled to a <strong>{planName}</strong>
			</div>
		</Alert>
	);
};

export default BOPAlertCaution;
